import React, { useState, useEffect } from "react";
import Layout from "../../components/include/layout";
import { getBlogBanner, getBlogs } from "../../data/api";
import SeoTags from "../../utils/seoTags";
import HeroBanner from "../../components/customcomponents/herobanner";
import TreandingSection from "../components/TreandingSection";
import DiscoverSection from "../components/DiscoverSection";
import BlogSection from "../components/BlogSection";
import CustomBanner from "../components/CustomBanner";
import "../../scss/blog/blog.scss";
import Loading from "../../components/customcomponents/loading";

function BlogHome() {
   const [banner, setBanner] = useState("");
   const [seo, setSeo] = useState("");
   const [featuredBlogs, setFeaturedBlogs] = useState([]);
   const [blogCategory, setBlogCategory] = useState([]);
   const [blogs, setBlogs] = useState([]);
   const [loading, setLoading] = useState(true);

   useEffect(() => {
      async function getData() {
         setLoading(true);
         const response = await getBlogBanner();
         const blogResponse = await getBlogs();
         setBanner(response?.data?.banners);
         setSeo(response?.data?.seo);
         setFeaturedBlogs(response?.data?.featuredBlogs);
         setBlogCategory(response?.data?.blogCategory);
         setBlogs(blogResponse?.data?.data);
         setLoading(false);
      }
      getData();
   }, []);

   return loading ? (
      <Loading />
   ) : (
      <Layout footer={"blog"}>
         {Object.entries(seo).map(([key, value]) => {
            if (value?.page === "blog") {
               return SeoTags(
                  value?.title,
                  value?.title,
                  "",
                  value?.keyword,
                  "",
                  `${process.env.REACT_APP_PUBLIC_URL}company/blogs`,
               );
            } else {
               return null;
            }
         })}
         {/* {Object.entries(banner).map(([key, value]) => {
            if (value.page_location === "blog") {
               return <HeroBanner data={value} />;
            } else {
               return null;
            }
         })} */}
         {featuredBlogs?.length > 0 && <CustomBanner data={featuredBlogs} />}
         {/* {featuredBlogs?.length > 0 && <TreandingSection data={featuredBlogs} />} */}
         {blogCategory?.length > 0 && <DiscoverSection data={blogCategory} />}
         {blogs?.length > 0 && <BlogSection data={blogs} />}
      </Layout>
   );
}

export default BlogHome;
